import React, { Component } from 'react';


import {
  Link
} from 'react-router-dom';


import Item from '../../components/Item'
import Content from '../../components/Content'
import Grid from '../../components/Grid'
import Media from '../../components/Media'
import Icon from '../../components/Icon'

import FadeIn from '../../components/FadeIn'


import moment from 'moment';

import Asset from '../../models/Asset'
import Entry from '../../models/Entry'


class NewsGroup extends Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() {

  }

  componentWillUnmount() {

  }

  getImage = (item) => {
      return (
      <div className="Item-media">
                          
                    <Link to={item.uri}><Media fluid={false} id={item.image[0]} /></Link>
                        </div>)
    
  }

  getIntro = (item) => {
      return (
      <div className="Item-body">
                        <div className="Item-title">
                          <Content html={item.summary}/>

                          <div className="Item-more">
                            <Link to={item.uri}>
                              <Icon type="arrow-right-yellow" />
                            </Link>
                          </div>
                        </div>
                      </div>)
    
    
  }

  /*formatLabel = (label) ={ 
      if(this.props.filter == 'date') return this.getDate(label)
      else return label
  }
*/
  getDate = (dateStr) => {
    return moment(dateStr).format('ddd MM.DD');
  }

  getTime = (dateStr) => {
    return moment(dateStr).format('h.mma');
  }

  getSubtitle = (item) => {

      switch(this.props.filter){

          case 'location':
          return (item.newsCategory+' - '+this.getDate(item.postDate));
          break;
          case 'type':
          return (this.getDate(item.postDate));
          break;
          default:
          return (item.newsCategory);
          break;

      }

  }

  

  /*

    RENDER

  */

  render() {
   

        let {label,items,ix} = this.props;

        return (

        
          <div className={"Template-section Template-section--narrow "+ (((ix+1) % 2 == 0) ? 'Template-section--even' : 'Template-section--odd')}>

            <div className="Template-heading">
              <Content>
                <h3>{label} </h3>
              </Content>
            </div>
            <div className="Template-content">
                {items.map((item) => (

                  <Item modifiers={['article']}>

                      {this.getImage(item)}

                      <div className="Item-head">
                        <div className="Item-title">
                          <Content modifier={'yellow'}>
                            <h4>
                    <Link to={item.uri}>{item.title}</Link></h4>
                          </Content>
                          <Content>
                            <h4>
                              {this.getSubtitle(item)}
                            </h4>
                          </Content>
                        </div>

                        
                      </div>


                      {this.getIntro(item)}

                  </Item>

                ))}
            </div>

          </div>

        )

  }
}

export default NewsGroup;



// WEBPACK FOOTER //
// ./src/js/components/NewsGroup/NewsGroup.jsx